export default "__VITE_ASSET__BGbgztIn__"